import { Viewer } from "../Viewer";

window.WBApp = window.WBApp || {};
window.WBApp.utils = window.WBApp.utils || {};

window.WBApp.utils.Viewer = Viewer;

import { getSectionModel } from "./roof.sectionModel";
import { getPurlinModel } from "./roof.purlinModel";

window.WBApp.utils.getSectionModel = getSectionModel;
window.WBApp.utils.getPurlinModel = getPurlinModel;

import {detectDoubleTap} from "../doubleTapEvent";
document.addEventListener('pointerup', detectDoubleTap(300));